module.exports = __webpack_public_path__ + "img/holzdeck01.00872e98.jpg";